import {
  en_defaultTranslations,
  en_uberTranslations,
  es_defaultTranslations,
  es_uberTranslations,
} from "@hopper-b2b/i18n";
import { type Translation, TranslationLanguage } from "@hopper-b2b/types";
import { merge } from "lodash-es";

const translation: Translation = {
  [TranslationLanguage.en]: merge(en_defaultTranslations, en_uberTranslations),
  [TranslationLanguage.es]: merge(es_defaultTranslations, es_uberTranslations),
};

export default translation;
